import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ExternalLink, Pencil, Plus, Sparkles, Trash2 } from "lucide-react";
import { api, img, useApi } from "@/lib/api";
import { AdminHeader } from "@/pages/admin/AdminLayout";

export default function AdminPosts() {
  const { data, reload } = useApi("/admin/posts", []);
  const remove = async (p) => {
    if (!window.confirm(`Delete "${p.title}"?`)) return;
    await api.delete(`/admin/posts/${p.id}`);
    toast.success("Story deleted");
    reload();
  };
  return (
    <div data-testid="admin-posts">
      <AdminHeader title="Stories / Blog">
        <Link to="/admin/posts/new?ai=1" className="btn-primary" data-testid="posts-new-ai"><Sparkles className="h-4 w-4" /> Write with AI</Link>
        <Link to="/admin/posts/new" className="btn-outline" data-testid="posts-new"><Plus className="h-4 w-4" /> New story</Link>
      </AdminHeader>
      <div className="overflow-hidden rounded-2xl border border-clay bg-white">
        {data.length === 0 && <p className="p-8 text-moss">No stories yet.</p>}
        {data.map((p) => (
          <div key={p.id} className="flex flex-col gap-4 border-b border-clay p-4 last:border-b-0 sm:flex-row sm:items-center" data-testid={`admin-post-row-${p.slug}`}>
            {p.cover_image ? <img src={img(p.cover_image)} alt="" className="h-20 w-28 shrink-0 rounded-lg object-cover" /> : <div className="h-20 w-28 shrink-0 rounded-lg bg-clay" />}
            <div className="min-w-0 flex-1">
              <p className="truncate font-bold text-ink">{p.title}</p>
              <div className="mt-1 flex flex-wrap gap-2 text-xs font-bold">
                <span className={`rounded-full px-2 py-0.5 ${p.published ? "bg-sage/20 text-forest" : "bg-clay text-moss"}`}>{p.published ? "Published" : "Draft"}</span>
                <span className={`rounded-full px-2 py-0.5 ${p.es?.title ? "bg-sand/50 text-ink" : "bg-linen text-moss"}`}>{p.es?.title ? "ES ready" : "ES pending"}</span>
                {(p.video_url || p.video_file) && <span className="rounded-full bg-linen px-2 py-0.5 text-moss">Video</span>}
              </div>
            </div>
            <div className="flex gap-2">
              <a href={`/stories/${p.slug}`} target="_blank" rel="noreferrer" className="rounded-lg border border-clay p-2.5 text-moss hover:text-forest" aria-label="View" data-testid={`admin-post-view-${p.slug}`}><ExternalLink className="h-4 w-4" /></a>
              <Link to={`/admin/posts/${p.id}`} className="rounded-lg border border-clay p-2.5 text-moss hover:text-forest" aria-label="Edit" data-testid={`admin-post-edit-${p.slug}`}><Pencil className="h-4 w-4" /></Link>
              <button onClick={() => remove(p)} className="rounded-lg border border-clay p-2.5 text-moss hover:text-destructive" aria-label="Delete" data-testid={`admin-post-delete-${p.slug}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
